<template>
  <div
    v-if="bannerStore.hasData"
    :class="bannerStore.bgColor ?? 'bg-surface-highlight'"
  >
    <div class="page-wrapper py-16 flex flex-row gap-12">
      <nuxt-icon
        class="text-[3.6rem] py-2"
        filled
        aria-hidden="true"
        :name="bannerStore.icon ?? 'alert-circle'"
      />
      <div class="flex flex-col gap-8 mr-auto">
        <p class="heading-xxs">{{ bannerStore.title }}</p>
        <p class="">{{ bannerStore.text }}</p>
      </div>
      <AppButton
        v-if="bannerStore.linkButtonUrl && bannerStore.linkButtonText"
        class="items-center"
        color="secondary"
        size="default"
        :href="bannerStore.linkButtonUrl"
      >
        {{ bannerStore.linkButtonText }}
      </AppButton>
      <nuxt-icon
        role="button"
        aria-label="Stäng meddelandet"
        filled
        name="x"
        class="text-[2.4rem] self-baseline p-12 pt-0 cursor-pointer"
        @click="bannerStore.clear"
      ></nuxt-icon>
    </div>
  </div>
</template>

<script lang="ts" setup>
const bannerStore = useBannerStore();
</script>

<style scoped lang="scss"></style>
